import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CabinetsService } from '../../data/cabinets.service';
import { ShortObject } from '../../../project-misc/data/project/short-json-object';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';

@Component({
  selector: 'app-hidden-cabinets-dialog',
  templateUrl: './hidden-cabinets-dialog.component.html',
  styleUrls: ['./hidden-cabinets-dialog.component.scss']
})
export class HiddenCabinetsDialogComponent implements OnInit, OnDestroy {
  hiddenCabinets: ShortObject[] = [];
  isLoading = false;
  private destroy$ = new Subject<boolean>();

  constructor(
    private dialogRef: MatDialogRef<HiddenCabinetsDialogComponent>,
    private cabinetsService: CabinetsService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: { projectId: number }
  ) {}

  trackById(index: number, item: ShortObject): number {
    return item.id;
  }

  ngOnInit(): void {
    this.loadHiddenCabinets();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  loadHiddenCabinets(): void {
    this.isLoading = true;
    this.cabinetsService.getIgnoredCabinets().pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (cabinets) => {
        this.hiddenCabinets = cabinets;
        this.isLoading = false;
      },
      (error) => {
        this.miscSnackBarService.openErrorSnackBar('Failed to load hidden cabinets');
        this.isLoading = false;
      }
    );
  }

  restoreCabinet(cabinet: ShortObject): void {
    this.cabinetsService.removeIgnoredCabinet(cabinet.id).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      () => {
        this.hiddenCabinets = this.hiddenCabinets.filter(c => c.id !== cabinet.id);
      },
      (error) => {
        this.miscSnackBarService.openErrorSnackBar('Failed to restore cabinet');
      }
    );
  }

  onClose(): void {
    this.dialogRef.close('refresh');
  }
}
